import { render, staticRenderFns } from "./tcColorPicker.vue?vue&type=template&id=12af7e8a&scoped=true"
import script from "./tcColorPicker.vue?vue&type=script&lang=js"
export * from "./tcColorPicker.vue?vue&type=script&lang=js"
import style0 from "./tcColorPicker.vue?vue&type=style&index=0&id=12af7e8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af7e8a",
  null
  
)

export default component.exports